import { motion } from "framer-motion";
import { Mail, Phone, Linkedin } from "lucide-react";

const Contact = () => {
  return (
    <section className="page-shell flex min-h-screen items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="page-panel w-full max-w-3xl rounded-3xl p-8 md:p-12"
      >
        <h2 className="section-title mb-8 text-center text-3xl font-bold md:text-4xl">
          Get In Touch
        </h2>

        <form className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="section-title block text-sm font-semibold"
            >
              Your Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="John Doe"
              className="mt-1 block w-full rounded-xl border border-[color:var(--card-border)] bg-[color:var(--surface-strong)] px-4 py-3 text-[color:var(--text)] shadow-sm outline-none placeholder:text-[color:var(--text-soft)] focus:border-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]"
              required
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="section-title block text-sm font-semibold"
            >
              Your Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="you@example.com"
              className="mt-1 block w-full rounded-xl border border-[color:var(--card-border)] bg-[color:var(--surface-strong)] px-4 py-3 text-[color:var(--text)] shadow-sm outline-none placeholder:text-[color:var(--text-soft)] focus:border-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]"
              required
            />
          </div>

          <div>
            <label
              htmlFor="message"
              className="section-title block text-sm font-semibold"
            >
              Your Message
            </label>
            <textarea
              id="message"
              rows={5}
              placeholder="Write your message here..."
              className="mt-1 block w-full rounded-xl border border-[color:var(--card-border)] bg-[color:var(--surface-strong)] px-4 py-3 text-[color:var(--text)] shadow-sm outline-none placeholder:text-[color:var(--text-soft)] focus:border-[color:var(--primary)] focus:ring-2 focus:ring-[color:var(--primary)]"
              required
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            className="w-full rounded-xl bg-[color:var(--primary)] px-6 py-3 font-semibold text-white transition duration-300 hover:bg-[color:var(--primary-strong)]"
          >
            Send Message
          </motion.button>
        </form>

        {/* Contact Info Section with Icons */}
        <div className="body-copy mt-10 space-y-3 text-center text-sm">
          <div className="page-card flex items-center justify-center gap-2 rounded-xl px-4 py-3">
            <Mail size={18} className="text-[color:var(--primary)]" />
            <a
              href="mailto:amrelshimy1@gmail.com"
              className="section-kicker font-medium underline"
            >
              amrelshimy1@gmail.com
            </a>
          </div>

          <div className="page-card flex items-center justify-center gap-2 rounded-xl px-4 py-3">
            <Phone size={18} className="text-[color:var(--primary)]" />
            <span className="font-medium text-[color:var(--text-muted)]">
              +90 551 391 67 43
            </span>
          </div>

          <div className="page-card flex items-center justify-center gap-2 rounded-xl px-4 py-3">
            <Linkedin size={18} className="text-[color:var(--primary)]" />
            <a
              href="https://linkedin.com/in/amrelshimy"
              target="_blank"
              rel="noreferrer"
              className="section-kicker font-medium underline"
            >
              linkedin.com/in/amrelshimy
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
